<template>
  <div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <MapPolyline
        ref="mapPolyline"
        :polylineCode="polylineCode"
        :strokeWeight="strokeWeight"
        :strokeColour="routeColour"
        :strokeOpacity="strokeOpacity"
        :borderWeight="2.5"
        :borderColour="darkenColour(routeColour, 15)"
        :google="google"
        :map="map"
        @click="onClicked($event)"
      />

      <MapMarker
        v-for="marker in markerList"
        :key="marker.id"
        :position="marker.position"
        :type="marker.type"
        :label="marker.label"
        :fillColour="marker.fillColour"
        :strokeColour="marker.strokeColour"
        :google="google"
        :map="map"
        @click="onClicked($event)"
      />
    </template>
  </div>
</template>

<script>
import MapMarker from '@/components/maps/mapMarker'
import MapPolyline from '@/components/maps/mapPolyline'
import ColourMixin from '@/mixins/colour'

export default {
  name: 'TaskMapRoute',
  mixins: [ColourMixin],
  components: {
    MapMarker,
    MapPolyline
  },
  props: {
    routeColour: String,
    polylineCode: String,
    itemPoints: Array,
    strokeWeight: {
      type: Number,
      default: 2.0
    },
    strokeOpacity: {
      type: Number,
      default: 1.0
    },
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    }
  },
  computed: {
    markerList() {
      if(!this.itemPoints)
        return []

      return this.itemPoints.map((point, index) => {
        if(index == 0) {
          return {
            id: this.getUniqueListKey(),
            position: point,
            type: MapMarker.MapMarkerTypes.routeStart,
            fillColour: this.routeColour,
            strokeColour: this.darkenColour(this.routeColour, 30)
          }
        }
        return {
          id: this.getUniqueListKey(),
          position: point,
          type: MapMarker.MapMarkerTypes.routeWaypoint,
          fillColour: '#ffffff',
          strokeColour: '#000000'
        }
      })
    }
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    },
    polylineUpdated() {
      if(this.$refs.mapPolyline) {
        this.$refs.mapPolyline.polylineUpdated()
      }
    }
  }
}
</script>